import React, { useState, useEffect, useRef } from 'react';
import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
import axios from 'axios';
import { FaSave } from 'react-icons/fa';
import { useLoader } from "../../../../../context/LoaderProvider.jsx";
import * as XLSX from 'xlsx';
const Grocerystandardmenu = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [addedItems, setAddedItems] = useState([]);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [image, setImage] = useState(null);
    const [text, setText] = useState('');
    const [isVegSelected, setIsVegSelected] = useState(null);
    const [dishId, setDishId] = useState(null);
    const [packageOrLitre, setPackageOrLitre] = useState('');
    // Add near other useState hooks
    const [quantityType, setQuantityType] = useState("");
    const [quantityValue, setQuantityValue] = useState("");

    const [imageFile, setImageFile] = useState(null); // new state for the File
    const [dishType, setDishType] = useState("");

    const [selectedImages, setSelectedImages] = useState([]);
    const fileInputRef = useRef(null);
    const [showSubcategoryPopup, setShowSubcategoryPopup] = useState(false);
    const [subDishName, setSubDishName] = useState('');
    const [price, setPrice] = useState('');
    const [description, setDescription] = useState('');
    const [discount, setdiscount] = useState('');
    const [packingCharges, setPackingCharges] = useState("");
    const [gstPercentage, setGstPercentage] = useState("");
    const [parentDishDetails, setParentDishDetails] = useState(null);
    const { showLoader, hideLoader } = useLoader();
    const [filteredData, setFilteredData] = useState([]); // Filtered by tag
    // const [image, setImage] = useState('');
    const [showSubEditModal, setShowSubEditModal] = React.useState(false);
    const [editSubItem, setEditSubItem] = React.useState({
        dishId: '',
        subName: '',
        discount: '',
        price: '',
        stockQuantity: '',
        gst: '',
        packingCharges: '',
        image: '',
        chefType: '',
        parentIndex: null,
        subIndex: null,
    });
    const applyFilter = (allData, vegOnly) => {
        if (vegOnly === null) {
            setFilteredData(allData); // No filter, show all
            return;
        }

        const filtered = allData.map(category => {
            const filteredSubcategories = category.subcategories.filter(
                sub => vegOnly ? sub.tag === "Veg" : sub.tag === "Non_Veg"
            );

            return {
                ...category,
                subcategories: filteredSubcategories
            };
        }).filter(cat => cat.subcategories.length > 0); // only show categories with subcategories

        setFilteredData(filtered);
    };




    // ---------- handleEditSubcategory ----------
    const handleEditSubcategory = async (subDishId, subIndex, parentIndex) => {
        try {
            console.log("✏️ handleEditSubcategory called with id:", subDishId);

            if (!subDishId) {
                alert("No subDishId passed to handler!");
                return;
            }

            setDishId(subDishId);

            const token = localStorage.getItem("authToken");
            if (!token) {
                alert("Authentication token missing. Please log in again.");
                return;
            }

            const response = await axios.get(
                `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/grocery/dishes/${subDishId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            console.log("🧾 raw API response for subDish:", response.data);

            // Normalize response shape
            let subDish = response.data;
            if (subDish && subDish.data) subDish = subDish.data;
            if (Array.isArray(subDish)) {
                const found = subDish.find(d => Number(d.dishId || d.id) === Number(subDishId));
                subDish = found || subDish[0];
            }

            console.log("🔎 parsed subDish:", subDish);

            if (!subDish) {
                alert(`Sub-dish data not found for id ${subDishId}`);
                return;
            }

            const resolvedId = subDish.dishId ?? subDish.id ?? subDish._id ?? subDish.ID;
            if (!resolvedId) {
                console.error("No valid ID field found on subDish:", subDish);
                alert("Sub-dish ID missing in API response. Check backend response.");
                return;
            }

            setEditSubItem({
                dishId: resolvedId,
                subName: subDish.dishName ?? subDish.subName ?? "",
                price: subDish.price ?? "",
                stockQuantity: subDish.stockQuantity ?? "",
                gst: subDish.gst ?? "",
                packingCharges: subDish.packingCharges ?? "",
                image: subDish.dishImage ?? subDish.image ?? "",
                chefType: subDish.chefType ?? "",
                parentIndex,
                subIndex,
            });

            setShowSubEditModal(true);
        } catch (error) {
            console.error("Error in handleEditSubcategory:", error);
            alert("Error fetching subcategory details:\n" + (error.response?.data?.message || error.message));
        }
    };


    // ---------- submitEditSubcategory ----------
    const submitEditSubcategory = async () => {
        console.log("🧾 submitEditSubcategory - editSubItem:", editSubItem);

        if (!editSubItem || !(editSubItem.dishId ?? editSubItem.id)) {
            alert("Subcategory Dish ID is missing!");
            console.error("Missing dishId in editSubItem:", editSubItem);
            return;
        }

        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                alert("Authentication token not found!");
                return;
            }

            const idToSend = editSubItem.dishId ?? editSubItem.id;
            const url = `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/dishes/${idToSend}`;
            console.log("🔗 PUT URL:", url);

            const formData = new FormData();

            const dishData = {
                dishName: editSubItem.subName,
                price: editSubItem.price,
                stockQuantity: editSubItem.stockQuantity,
                gst: editSubItem.gst,
                packingCharges: editSubItem.packingCharges,
                chefType: editSubItem.chefType,
            };

            formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

            if (editSubItem.newImageFile) {
                formData.append("image", editSubItem.newImageFile);
            }

            const response = await axios.put(url, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            console.log("✅ Subcategory update response:", response.data);
            alert("Subcategory updated successfully!");
            setShowSubEditModal(false);
            // Prefer re-fetching data instead of full reload:
            // await fetchData(); // implement fetchData to refresh list
            window.location.reload();
        } catch (error) {
            console.error("Error updating subcategory:", error);
            if (error.response) {
                console.error("Response data:", error.response.data);
                alert(`Failed to update subcategory: ${error.response.data.message || JSON.stringify(error.response.data)}`);
            } else {
                alert(`Failed to update subcategory: ${error.message}`);
            }
        }
    };





    const handleAddSubCategory = async (id) => {
        console.log("🟢 Fetching dish data for ID:", id);

        const url = `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/grocery/dishes/${id}`;
        const token = localStorage.getItem("authToken");

        if (!token) {
            alert("Authentication token missing. Please log in again.");
            return;
        }

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Accept": "*/*",
                    "Authorization": `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const dishData = await response.json();
            console.log("✅ Dish data fetched successfully:", dishData);

            // Save parent details for popup
            setParentDishDetails(dishData);

            // Open popup
            setShowSubcategoryPopup(true);
        } catch (error) {
            console.error("❌ Failed to fetch dish data:", error);
            // Even if fetch fails, test the popup manually:
            // setShowSubcategoryPopup(true);
        }
    };





    // ✅ Handle multiple image selection
    const handleSubImageChange = (e) => {
        const files = Array.from(e.target.files);
        setSelectedImages(files);
        if (files.length > 0) {
            setImage(URL.createObjectURL(files[0])); // preview the first one
        }
    };

    const handleSubcategorySubmit = async () => {
        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");

        if (!token) {
            alert("Authentication token missing. Please log in again.");
            return;
        }

        if (!subDishName || !price || !parentDishDetails) {
            alert("Please fill all required fields.");
            return;
        }

        if (!selectedImages || selectedImages.length === 0) {
            alert("Please upload an image for the subcategory.");
            return;
        }

        try {
            showLoader();

            const dishData = {
                vendorId,
                dishName: subDishName,
                dishDescription: description || "",
                dishPrice: parseFloat(price) || 0,
                parentId: parentDishDetails?.id || parentDishDetails?.parentId || 0,
                discountPercentage: parseFloat(discount) || 0,
                quantityType: quantityType || "",
                quantityValue: quantityValue || "",
                gstPercentage: gstPercentage ? parseFloat(gstPercentage) : 0,
                packingCharges: packingCharges ? parseFloat(packingCharges) : 0,
                available: true,
                effectivePrice: (
                    price - (price * (discount || 0)) / 100
                ).toFixed(2),
            };

            // ✅ Prepare FormData properly
            const formData = new FormData();
            formData.append(
                "dishData",
                new Blob([JSON.stringify(dishData)], { type: "application/json" })
            );
            formData.append("image", selectedImages[0]);

            console.log("📦 Uploading Subcategory Data:", dishData);
            console.log("🖼️ Image file being sent:", selectedImages[0].name);

            const response = await fetch(
                `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/dishes?vendorId=${vendorId}`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    body: formData,
                }
            );

            if (!response.ok) {
                const errorText = await response.text();
                console.error("❌ Server Response:", errorText);
                throw new Error(`HTTP ${response.status}: ${errorText}`);
            }

            const result = await response.json();
            console.log("✅ Subcategory added successfully:", result);
            alert(`✅ Subcategory "${result.dishName}" added successfully!`);
            setShowSubcategoryPopup(false);
            fetchData();
        } catch (error) {
            console.error("❌ Error adding subcategory:", error);
            alert("Failed to add subcategory!");
        } finally {
            hideLoader();
        }
    };





    const handleSave = async () => {
        if (!text.trim() || !imageFile || !dishType) {
            alert("Please provide dish name, type, and image.");
            return;
        }

        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId) {
            alert("Vendor ID not found. Please log in again.");
            return;
        }

        if (!token) {
            alert("Authentication token missing. Please log in again.");
            return;
        }

        try {
            showLoader()
            const formData = new FormData();

            const dishData = {
                dishId: 0,
                price: 0,
                dishName: text.trim(),
                parentId: 0,
                stockQuantity: 0,
                gst: 0,
                packingCharges: 0,
                dishType: dishType, // ✅ Added dishType
            };

            formData.append(
                "dishData",
                new Blob([JSON.stringify(dishData)], { type: "application/json" })
            );
            formData.append("image", imageFile);

            const response = await axios.post(
                `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/dishes?vendorId=${vendorId}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            alert("Item added successfully!");
            setShowPopup(false);
            setText("");
            setDishType("");
            setImageFile(null);
            setImage(null);
        } catch (error) {
            console.error("Upload failed:", error.response?.data || error.message);
            alert(
                "Failed to add item: " +
                (error.response?.data?.message || "Unknown error")
            );
        } finally {
            hideLoader()
        }
    };




    const handleExport = () => {
        if (!filteredData || filteredData.length === 0) {
            alert("No data available to export.");
            return;
        }

        // Prepare export data including subcategories
        const exportData = [];

        filteredData.forEach((category, index) => {
            // Add main category row
            exportData.push({
                "S.No": index + 1,
                "Category": category.categoryName || "",
                "Subcategory": "",
                "Price": category.price || "",
                "Quantity": category.stockQuantity || "",
                "Consumed": category.consumedQuantity || "",
                "Balance": category.balanceQuantity || "",
                "Tag": category.tag || "",
                "GST": category.gst || "",
                "Packing": category.packingCharges || "",
                "Chef Type": category.chefType || "",
                "Item Status": category.menuStatus || "",
                "Description": category.description || "",
            });

            // Add subcategories (if any)
            if (category.subcategories && category.subcategories.length > 0) {
                category.subcategories.forEach((sub) => {
                    exportData.push({
                        "S.No": "",
                        "Category": category.categoryName || "",
                        "Subcategory": sub.subcategoryName || "",
                        "Price": sub.price || "",
                        "Quantity": sub.stockQuantity || "",
                        "Consumed": sub.consumedQuantity || "",
                        "Balance": sub.balanceQuantity || "",
                        "Tag": sub.tag || "",
                        "GST": sub.gst || "",
                        "Packing": sub.packingCharges || "",
                        "Chef Type": sub.chefType || "",
                        "Item Status": sub.menuStatus || "",
                        "Description": sub.description || "",
                    });
                });
            }
        });

        // Create Excel sheet
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Menu Data");

        // Auto-size columns
        const colWidths = Object.keys(exportData[0]).map((key) => ({
            wch: Math.max(
                key.length,
                ...exportData.map((row) => String(row[key] || "").length)
            ),
        }));
        worksheet["!cols"] = colWidths;

        // Download Excel file
        XLSX.writeFile(workbook, "menu_data_export.xlsx");
    };

    const handleFileImport = async (e) => {
        const file = e.target.files[0];
        if (!file) return alert("Please choose a file.");

        const reader = new FileReader();
        reader.onload = async (event) => {
            try {
                const data = new Uint8Array(event.target.result);
                const workbook = XLSX.read(data, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);

                // ✅ Get vendorId and auth token
                const vendorId = localStorage.getItem("vendorId");
                const authToken = localStorage.getItem("authToken");

                if (!vendorId) {
                    alert("Vendor ID not found in local storage.");
                    return;
                }
                if (!authToken) {
                    alert("No auth token found. Please log in first.");
                    return;
                }

                // ✅ Format data for API (include vendorId)
                const formatted = jsonData.map((row) => ({
                    dishName: row.dishName || "",
                    parentId: Number(row.parentId) || 0,
                    dishId: Number(row.dishId) || 0,
                    vendorId: Number(vendorId), // ✅ attach vendorId
                }));

                alert("📄 Imported Data:\n\n" + JSON.stringify(formatted, null, 2));

                // ✅ Send POST with Authorization header
                const response = await axios.post(
                    "http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/dishes",
                    formatted,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${authToken}`,
                        },
                    }
                );

                console.log("✅ Import successful:", response.data);
                alert("✅ Categories imported successfully!");

                // Optional small delay before reload to ensure DB write finishes
                setTimeout(() => window.location.reload(), 1000);

            } catch (error) {
                console.error("❌ Import failed:", error);
                alert("❌ Failed to import categories.");
            }
        };

        reader.readAsArrayBuffer(file);
    };

    const handleEdit = async (id) => {
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                alert("Authentication token missing. Please log in again.");
                return;
            }

            showLoader();

            const response = await axios.get(
                `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/grocery/dishes/${id}`,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            console.log("Dish Response Data:", response.data);

            const dish = response.data.data || response.data;

            if (!dish) {
                alert(`Dish with ID ${id} not found`);
                return;
            }

            setEditItem({
                dishId: dish.dishId || dish.id, // ✅ fixed
                dishName: dish.dishName || "",
                image: dish.dishImage || "",
                price: dish.price || "",
                gst: dish.gst || "",
            });

            setShowEditModal(true);
        } catch (error) {
            console.error("Error fetching dish details:", error);
            alert(
                "Error fetching dish details:\n" +
                (error.response?.data?.message || error.message)
            );
        } finally {
            hideLoader();
        }
    };




    const submitEdit = async () => {
        console.log("🧾 Submitting edit:", editItem);

        if (!editItem.dishId) {
            alert("❌ Dish ID is missing — cannot update!");
            console.error("Missing dishId in editItem:", editItem);
            return;
        }

        const token = localStorage.getItem("authToken");
        if (!token) {
            alert("Authentication token missing. Please log in again.");
            return;
        }

        try {
            showLoader();

            const url = `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/dishes/${editItem.dishId}`;
            console.log("🔗 PUT URL:", url);

            const formData = new FormData();
            const dishData = {
                dishName: editItem.dishName,
            };

            formData.append(
                "dishData",
                new Blob([JSON.stringify(dishData)], { type: "application/json" })
            );

            if (editItem.newImageFile) {
                formData.append("image", editItem.newImageFile);
            }

            const response = await axios.put(url, formData, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            console.log("✅ Edit successful:", response.data);
            alert("Dish updated successfully!");
            setShowEditModal(false);
            window.location.reload();
        } catch (error) {
            console.error("❌ Error updating dish:", error);
            alert(
                `Failed to update dish: ${error.response?.data?.message || error.message
                }`
            );
        } finally {
            hideLoader();
        }
    };



    const handleEditImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setEditItem(prev => ({
                ...prev,
                newImageFile: file,                  // store the file for upload
                image: URL.createObjectURL(file)     // preview
            }));
        }
    };

    const fetchData = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) {
            console.warn("⚠️ Missing vendorId or token");
            setError(new Error("Missing vendorId or token"));
            setLoading(false);
            return;
        }

        try {
            showLoader()
            const response = await fetch(
                `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/dishes-vendor/${vendorId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const dishData = await response.json();
            console.log("✅ Full dish data:", dishData);

            // Normalize parentId to numeric and handle null
            const normalized = dishData.map(d => ({
                ...d,
                parentId: d.parentId ? Number(d.parentId) : 0
            }));

            // Create a map of all dishes for quick lookup
            const dishMap = {};
            normalized.forEach(dish => {
                dishMap[dish.id] = { ...dish, subcategories: [] };
            });

            // Link subcategories to their parent
            normalized.forEach(dish => {
                if (dish.parentId && dish.parentId !== 0 && dishMap[dish.parentId]) {
                    dishMap[dish.parentId].subcategories.push(dish);
                }
            });

            // Take only parent categories
            const formattedData = Object.values(dishMap)
                .filter(cat => cat.parentId === 0)
                .map(category => {
                    // 🟢 Debug alert to confirm subcategory mapping
                    if (category.subcategories.length > 0) {

                    } else {
                        console.log(`ℹ️ No subcategories for ${category.dishName}`);
                    }

                    return {
                        dishId: category.id,
                        SNo: category.id,
                        category: category.dishName,
                        image: category.dishImage || "",
                        isChecked: false,
                        parentId: category.parentId,
                        id: category.id,
                        isAdded: true,
                        dishType: category.dishType || "OTHER",
                        price: category.dishPrice || 0,
                        stockQuantity: category.stockQuantity || 0,
                        balanceQuantity: category.balanceQuantity || 0,
                        gst: category.gst || 0,
                        chefType: category.chefType || "",
                        subcategories: category.subcategories.map(sub => ({
                            dishId: sub.id,
                            subName: sub.dishName,
                            price: sub.dishPrice || 0,
                            description: sub.dishDescription || "",
                            dishImage: sub.dishImage || "",
                            menuStatus: sub.available ? "Enable" : "Disable",
                            tag: sub.dishType || "Veg",
                            stockQuantity: sub.stockQuantity || 0,
                            gstPercentage: sub.gstPercentage || 0,
                            packingCharges: sub.packingCharges || 0,
                            consumedQuantity: sub.consumedQuantity || 0,
                            balanceQuantity: sub.balanceQuantity || 0,
                            dishType: sub.dishType,
                            discount: sub.discountPercentage || 0,
                            effectivePrice: sub.effectivePrice || 0,
                        })),
                    };
                });

            console.log("📂 Final formatted data:", formattedData);
            setData(formattedData);

            // Apply filter after data is set
            setTimeout(() => {
                applyFilter(formattedData, isVegSelected);
            }, 0);

        } catch (error) {
            console.error("❌ Error fetching data:", error);
            setError(error);
        } finally {
            setLoading(false);
            hideLoader();
        }
    };


    useEffect(() => {
        fetchData();
    }, []);

    const handleCheckboxChange = (e, index) => {
        const { checked } = e.target;
        setData(prevData => {
            const updatedData = [...prevData];
            updatedData[index].isChecked = checked;
            return updatedData;
        });
    };

    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        setData(prevData =>
            prevData.map(item => ({
                ...item,
                isChecked: isChecked,
            }))
        );
    };


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage(reader.result); // this will include "data:image/...;base64,..."
            };
            reader.readAsDataURL(file);
        }
    };

    const handleToggleStatus = async (index, subIndex, dishId, currentStatus) => {
        console.log('Clicked Toggle', { index, subIndex, dishId, currentStatus });

        const vendorId = localStorage.getItem("vendorId");
        const authToken = localStorage.getItem("authToken");

        if (!vendorId || !authToken) {
            alert("Authentication failed. Please login again.");
            return;
        }

        const currentBool = currentStatus === "Enable";
        const newBool = !currentBool;
        const newStatus = newBool ? "Enable" : "Disable";

        console.log('Toggling to newStatus:', newStatus);

        // Optimistic UI update
        setData((prevData) => {
            const updatedData = [...prevData];

            if (subIndex === null || subIndex === undefined) {
                updatedData[index] = {
                    ...updatedData[index],
                    menuStatus: newStatus,
                };
            } else {
                updatedData[index].subcategories[subIndex] = {
                    ...updatedData[index].subcategories[subIndex],
                    menuStatus: newStatus,
                };
            }

            return updatedData;
        });

        try {
            const url = `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/dishes/${dishId}`;
            const payload = { menuStatus: newStatus };

            const response = await axios.put(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`, // ✅ Add this line
                },
            });

            console.log('Backend response:', response.data);

            localStorage.setItem(`menuStatus-${dishId}`, newStatus);

        } catch (error) {
            console.error('Failed to toggle menu visibility:', error);
            alert('Failed to update menu visibility.');

            // Rollback UI
            setData((prevData) => {
                const updatedData = [...prevData];

                if (subIndex === null || subIndex === undefined) {
                    updatedData[index].menuStatus = currentStatus;
                } else {
                    updatedData[index].subcategories[subIndex].menuStatus = currentStatus;
                }

                return updatedData;
            });
        }
    };

    const handleDeleteRow = async (index, dishId) => {
        if (!window.confirm("Are you sure you want to delete this dish?")) return;

        const token = localStorage.getItem("authToken");

        try {
            showLoader()
            const response = await fetch(
                `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/dishes/${dishId}`,
                {
                    method: "DELETE",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                    },
                }
            );

            if (response.ok) {
                alert("Dish deleted successfully!");
                const newData = data.filter(item => item.SNo !== dishId);
                setData(newData);
            } else {
                const result = await response.json();
                alert(`Failed to delete dish. Error: ${result.message || "Unknown error"}`);
            }
        } catch (error) {
            alert("An error occurred while deleting.");
            console.error(error);
        } finally {
            hideLoader();
        }
    };

    const handleDeleteSubcategory = async (subDishId, subIndex, parentIndex) => {
        if (!window.confirm("Are you sure you want to delete this subcategory?")) return;

        const token = localStorage.getItem("authToken");

        try {
            const response = await fetch(
                `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/dishes/${subDishId}`,
                {
                    method: "DELETE",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                    },
                }
            );

            if (response.ok) {
                alert("Subcategory deleted successfully!");

                setData(prevData => {
                    const newData = [...prevData];
                    const updatedSubcategories = [...newData[parentIndex].subcategories];
                    updatedSubcategories.splice(subIndex, 1);
                    newData[parentIndex] = {
                        ...newData[parentIndex],
                        subcategories: updatedSubcategories,
                    };
                    return newData;
                });
            } else {
                const result = await response.json();
                alert(`Failed to delete subcategory. Error: ${result.message || "Unknown error"}`);
            }
        } catch (error) {
            alert("An error occurred while deleting the subcategory.");
            console.error(error);
        } finally {
            hideLoader();
        }
    };

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        setData(prevData => {
            const updatedData = [...prevData];
            updatedData[index][name] = value;
            return updatedData;
        });
    };

    // const handleImageChange = (e) => {
    //   const file = e.target.files[0];
    //   if (file) {
    //     setImage(URL.createObjectURL(file));
    //   }
    // };



    const modalStyle = {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        zIndex: 1000,
        width: '400px', // Define a fixed width for better control over layout
    };

    const inputContainerStyle = {
        marginBottom: '15px',
    };

    const inputFieldStyle = {
        width: '100%',
        padding: '8px',
        fontSize: '14px',
        borderRadius: '5px',
        border: '1px solid #ddd',
    };



    const imagePreviewStyle = {
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100px',
        height: '100px',
        margin: '10px 0',
        borderRadius: '10px',
        border: '1px solid #ccc',
        overflow: 'hidden',
    };

    const imageStyle = {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    };

    // const fileInputStyle = {
    //   display: 'block',
    //   marginTop: '10px',
    // };

    const buttonContainerStyle = {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '20px',
        textAlign: "center"
    };
    const closeButtonStyle = {
        position: 'absolute',
        top: '10px',
        right: '10px',
        cursor: 'pointer',
    };

    const closeIconStyle = {
        fontSize: '24px',
        fontWeight: 'bold',
        marginBottom: '30px',
        color: '#888',
    };

    const buttonStyle = {
        // padding: '10px 20px',
        height: "32px",
        backgroundColor: '#b15cd6',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: "bold",
        marginTop: "10px"
    };

    const cancelButtonStyle = {
        padding: '10px 20px',
        backgroundColor: '#f44336',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '14px',
    };

    const styles = {
        overlay: {
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 1000,
        },
        popup: {
            background: '#fff',
            padding: '20px',
            borderRadius: '8px',
            width: '300px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
            textAlign: 'center',
        },
        image: {
            width: '100%',
            marginTop: '10px',
            borderRadius: '5px',
        },
        input: {
            marginTop: '10px',
            padding: '8px',
            width: '100%',
            borderRadius: '5px',
            border: '1px solid #ccc',
        },
        buttons: {
            marginTop: '15px',
            display: 'flex',
            justifyContent: 'center'
        },
        saveBtn: {
            padding: '8px 12px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
        },
        cancelBtn: {
            padding: '8px 12px',
            backgroundColor: '#f44336',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
        }
    };



    return (
        <div style={{ marginTop: "-60px" }}>
            <div style={{ position: 'relative', top: '-11px', }} className='standard-menu'>
                <style>
                    {`
               .custom-switch {
            position: relative;
            display: inline-block;
            width: 100px;
            height: 35px;
            margin-top:11px;
          }

          .custom-switch input {
            opacity: 0;
            width: 0;
            height: 0;
          }

          .custom-slider {
            position: absolute;
            cursor: pointer;
            transition: 0.4s;
            margin-left:-315px;
            font-weight: bold;
            font-size: 14px;
            color: #000;
            text-align: center;
            line-height: 35px;
            width: 100px;
            height: 40px;
            border-radius:5px;
            background-color: rgb(217, 217, 217);
          }

   .custom-slider::before {
  content: "";
  position: absolute;
  height: 16px;
  width: 16px;
  left: 3px;
  top: 10px;
  background-color: #000; /* default */
  transition: 0.4s;
  border-radius: 50%;
}

.custom-slider.veg::before {
  background-color: green;
}

.custom-slider.non-veg::before {
  background-color: red;
}
        `}
                </style>
                {/* <label className="custom-switch">
                    <input
                        type="checkbox"
                        checked={isVegSelected}
                        onChange={() => handleFilterClick(isVegSelected ? 'Non-Veg' : 'Veg')}
                    />
                    <span className={`custom-slider ${isVegSelected ? 'veg' : 'non-veg'}`}>
                        {isVegSelected ? 'Veg' : 'Non-Veg'}
                    </span>

                </label> */}


            </div>

            <br></br>
            <div style={{ display: 'flex', justifyContent: 'end', marginBottom: '5px' }}>

                {showPopup && (
                    <div style={styles.overlay}>
                        <div style={styles.popup}>

                            {/* Close icon */}
                            <div
                                style={{
                                    position: 'absolute',
                                    fontSize: '20px',
                                    cursor: 'pointer',
                                    color: '#888',
                                    fontWeight: 'bold',
                                    marginLeft: "243px",
                                    marginTop: "-18px"
                                }}
                                onClick={() => setShowPopup(false)}
                            >
                                ×
                            </div>

                            <h3>Add Item</h3>

                            {/* Image upload box */}
                            <div
                                style={{
                                    width: '141px',
                                    height: '123px',
                                    border: '2px dashed #aaa',
                                    borderRadius: '8px',
                                    margin: '10px auto',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    backgroundColor: '#f9f9f9',
                                    overflow: 'hidden',
                                    position: 'relative',
                                }}
                                onClick={() => document.getElementById('hiddenFileInput').click()}
                            >
                                {image ? (
                                    <img
                                        src={image}
                                        alt="Preview"
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                        }}
                                    />
                                ) : (
                                    <div
                                        style={{
                                            fontSize: '40px',
                                            color: '#bbb',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        +
                                    </div>
                                )}

                                <input
                                    id="hiddenFileInput"
                                    type="file"
                                    accept="image/*"
                                    style={{
                                        position: 'absolute',
                                        width: '100%',
                                        height: '100%',
                                        opacity: 0,
                                        cursor: 'pointer',
                                        top: 0,
                                        left: 0,
                                    }}
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                            setImageFile(file);
                                            const reader = new FileReader();
                                            reader.onloadend = () => setImage(reader.result);
                                            reader.readAsDataURL(file);
                                        }
                                    }}
                                />
                            </div>

                            {/* Dish Name Input */}
                            <input
                                type="text"
                                placeholder="Enter Category"
                                value={text}
                                onChange={(e) => setText(e.target.value)}
                                style={styles.input}
                            />

                            {/* Dish Type Dropdown */}
                            <select
                                value={dishType}
                                onChange={(e) => setDishType(e.target.value)}
                                style={styles.input}
                            >
                                <option value="">Select Dish Type</option>
                                {[
                                    "VEGETABLES",
                                    "FRUITS",
                                    "DAIRY",
                                    "BAKERY",
                                    "MEAT",
                                    "SEAFOOD",
                                    "SNACKS",
                                    "BEVERAGES",
                                    "GRAINS_AND_PULSES",
                                    "SPICES_AND_CONDIMENTS",
                                    "OILS_AND_GHEE",
                                    "FROZEN_FOODS",
                                    "PERSONAL_CARE",
                                    "HOUSEHOLD_SUPPLIES",
                                    "BABY_CARE",
                                    "PET_SUPPLIES",
                                    "ORGANIC_PRODUCTS",
                                    "READY_TO_EAT",
                                    "HEALTH_AND_WELLNESS",
                                    "OTHER",
                                ].map((type) => (
                                    <option key={type} value={type}>{type.replace(/_/g, ' ')}</option>
                                ))}
                            </select>

                            {/* Save Button */}
                            <div style={styles.buttons}>
                                <button onClick={handleSave} style={styles.saveBtn}>Save</button>
                            </div>
                        </div>
                    </div>
                )}



                <div className='importexportaddbutton' style={{ display: "flex", gap: "10px", marginTop: "-70px", padding: "10px,20px" }}>

                    <input
                        type="file"
                        accept=".xlsx, .xls"
                        ref={fileInputRef}
                        onChange={handleFileImport}
                        style={{ display: 'none' }}
                    />

                    <button
                        style={importExportButton}
                        onClick={() => fileInputRef.current.click()}
                    >
                        Import
                    </button>



                    <button style={importExportButton} onClick={handleExport}>Export</button>
                    <button style={importExportButton}

                        onClick={() => setShowPopup(true)}
                    >
                        Add+
                    </button>



                </div>

            </div>


            <div style={{
                overflowX: "auto",       // 👈 enable horizontal scroll
                overflowY: "scroll",     // 👈 still scrollable vertically
                height: "510px",
                scrollbarWidthY: "none",  // 👈 hide scrollbar (Firefox)
                // msOverflowStyle: "none", // 👈 hide scrollbar (IE/Edge)
            }}
                className="standard-table-data" >

                {loading ? (
                    <p>Loading data...</p>
                ) : error ? (
                    <p style={{ color: 'red' }}>Error fetching data: {error.message}</p>
                ) : (
                    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: "0px", minWidth: "1200px" }}>
                        <thead>
                            <tr style={{ backgroundColor: '#f2f2f2' }}>
                                <th style={tableHeaderStyle}><input type="checkbox" onChange={handleSelectAll} /></th>
                                <th style={tableHeaderStyle}>SNo</th>
                                <th style={tableHeaderStyle}>Category</th>
                                <th style={tableHeaderStyle}>Image</th>
                                <th style={tableHeaderStyle}>Price</th>
                                <th style={tableHeaderStyle}>Quantity</th>
                                <th style={tableHeaderStyle}>Consumed</th>
                                <th style={tableHeaderStyle}>Balance</th>
                                <th
                                    style={tableHeaderStyle}
                                >
                                    <th style={tableHeaderStyle}>Type</th>

                                </th>

                                <th style={tableHeaderStyle}>Description</th>
                                <th style={tableHeaderStyle}>Gst</th>
                                <th style={tableHeaderStyle}>Packing</th>
                                <th style={tableHeaderStyle}>Discount</th>
                                <th style={tableHeaderStyle}>ItemStatus</th>
                                <th style={tableHeaderStyle}>Actions</th>
                                {/* Add header for subcategory stock status */}

                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((item, index) => (

                                <React.Fragment key={index}>
                                    <tr style={index % 2 === 0 ? evenRowStyle : oddRowStyle}>
                                        <td style={tableCellStyle}>
                                            <input
                                                type="checkbox"
                                                checked={item.isChecked || false}
                                                onChange={(e) => handleCheckboxChange(e, index)}
                                            />
                                        </td>
                                        <td style={tableCellStyle}>{index + 1}</td>
                                        <td style={tableCellStyle}>
                                            <div>

                                                <input
                                                    type="text"
                                                    name="category"
                                                    value={item.category}
                                                    onChange={(e) => handleInputChange(e, index)}
                                                    style={inputStyle}
                                                />
                                            </div>
                                        </td>
                                        <td style={tableCellStyle}>
                                            <label htmlFor={`fileInput-${index}`} style={{ cursor: 'pointer' }}>
                                                <img
                                                    src={item.image}
                                                    alt="Dish"
                                                    style={{ width: '38px', height: '30px', borderRadius: '10px', marginTop: '-21px' }}
                                                />
                                            </label>
                                            <input
                                                id={`fileInput-${index}`}
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) => handleImageChange(e, index)}
                                                style={{ display: 'none' }}
                                            />
                                        </td>
                                        <td style={tableCellStyle}> {/* Price column for parent */}
                                            {item.price ? `₹${item.price}` : '-'}
                                        </td>
                                        <td style={tableCellStyle}> {/* Price column for parent */}
                                            {item.price ? `₹${item.price}` : '-'}
                                        </td>
                                        <td style={tableCellStyle}> {item.price ? `₹${item.price}` : '-'}</td>
                                        <td style={tableCellStyle}> {/* Price column for parent */}
                                            {item.stockQuantity ? `₹${item.stockQuantity}` : '-'}
                                        </td>
                                        <td style={{ ...tableCellStyle, color: "#2d3436", fontWeight: 500 }}>
                                            {item.dishType ? item.dishType.replace(/_/g, " ") : "-"}
                                        </td>
                                        <td style={tableCellStyle}> {/* Price column for parent */}
                                            {item.balanceQuantity ? `₹${item.balanceQuantity}` : '-'}
                                        </td>
                                        <td style={tableCellStyle}>
                                            {item.gst ? `₹${item.gst}` : '-'}
                                        </td>

                                        <td style={tableCellStyle}>
                                            {item.balanceQuantity ? `₹${item.chefType}` : '-'}
                                        </td>
                                        <td style={tableCellStyle}>
                                            {item.gst ? `₹${item.gst}` : '-'}
                                        </td>
                                        <td style={tableCellStyle}>
                                            {item.gst ? `₹${item.gst}` : '-'}
                                        </td>
                                        {/* <td style={tableCellStyle}>
                                            {item.packingCharges ? `₹${item.packingCharges}` : '-'}
                                        </td> */}
                                        <td style={tableCellStyle}>
                                            <button
                                                style={{
                                                    backgroundColor: '#00b894',
                                                    color: 'white',
                                                    borderRadius: '4px',
                                                    padding: '4px 8px',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    width: 'fit-content'
                                                }}
                                                onClick={() => handleAddSubCategory(item.id)}
                                            >
                                                Add
                                            </button>
                                            <button
                                                style={addButtonStyle}
                                                onClick={() => item.isAdded
                                                    ? handleEdit(item.dishId || item.id)
                                                    : handleSave(item, index)
                                                }

                                            >
                                                {item.isAdded ? <FaEdit /> : <FaSave />}
                                            </button>
                                            <button
                                                style={deleteButtonStyle}
                                                onClick={() => handleDeleteRow(index, item.SNo, item.parentId)}
                                            >
                                                <FaTrash />
                                            </button>
                                        </td>
                                        {/* Empty cell for stock status on parent row */}

                                    </tr>

                                    {/* Subcategories */}
                                    {item.subcategories && item.subcategories.length > 0 && item.subcategories.map((sub, subIndex) => {
                                        // ✅ Safely resolve subcategory ID (backend may return dishId, id, or _id)
                                        const subDishId = sub.dishId ?? sub.id ?? sub._id;

                                        return (
                                            <tr key={`sub-${subDishId || subIndex}`} style={{ backgroundColor: '#f9f9f9' }}>
                                                <td style={tableCellStyle}>-</td>
                                                <td style={tableCellStyle}>-</td>

                                                {/* Subcategory Name */}
                                                <td style={tableCellStyle}>↳ {sub.subName ?? sub.dishName ?? "Unnamed"}</td>

                                                {/* Image */}
                                                <td style={tableCellStyle}>
                                                    <img
                                                        src={sub.dishImage || sub.image || "https://via.placeholder.com/40"}
                                                        alt="Sub Dish"
                                                        style={{ width: '38px', height: '30px', borderRadius: '10px' }}
                                                    />
                                                </td>

                                                {/* Basic Info */}
                                                <td style={tableCellStyle}>₹{sub.price ?? 0}</td>
                                                <td style={tableCellStyle}>{sub.stockQuantity ?? "-"}</td>
                                                <td style={tableCellStyle}>{sub.consumedQuantity ?? "-"}</td>
                                                <td style={tableCellStyle}>{sub.balanceQuantity ?? "-"}</td>

                                                {/* Type */}
                                                <td style={{ ...tableCellStyle, color: "#636e72" }}>
                                                    {sub.dishType ? sub.dishType.replace(/_/g, " ") : "-"}
                                                </td>

                                                {/* Description, GST, Packing Charges, Discount */}
                                                <td style={tableCellStyle}>{sub.description ?? "-"}</td>
                                                <td style={tableCellStyle}>{sub.gstPercentage ?? "-"}</td>
                                                <td style={tableCellStyle}>{sub.packingCharges ?? "-"}</td>
                                                <td style={tableCellStyle}>{sub.discount ?? "-"}</td>

                                                {/* Show/Hide Toggle */}
                                                <td style={tableCellStyle}>
                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <label className="switch">
                                                            <input
                                                                type="checkbox"
                                                                checked={sub.menuStatus === "Disable"}
                                                                onChange={() => handleToggleStatus(index, subIndex, subDishId, sub.menuStatus)}
                                                            />
                                                            <span className="slider round"></span>
                                                        </label>
                                                        <span
                                                            style={{
                                                                marginTop: '4px',
                                                                color: 'black',
                                                                fontSize: '12px',
                                                                cursor: 'pointer',
                                                            }}
                                                        >
                                                            {sub.menuStatus === "Disable" ? 'Hide' : 'Show'}
                                                        </span>
                                                    </div>
                                                </td>

                                                {/* Action Buttons */}
                                                <td style={tableCellStyle}>
                                                    <div style={{ marginLeft: "40px", display: "flex", gap: "8px" }}>
                                                        {/* ✅ Edit Subcategory */}
                                                        <button
                                                            style={addButtonStyle}
                                                            onClick={() => {
                                                                console.log("🖊️ Edit Sub clicked:", subDishId, sub);
                                                                handleEditSubcategory(subDishId, subIndex, index);
                                                            }}
                                                        >
                                                            <FaEdit />
                                                        </button>

                                                        {/* 🗑️ Delete Subcategory */}
                                                        <button
                                                            style={deleteButtonStyle}
                                                            onClick={() => handleDeleteSubcategory(subDishId, subIndex, index)}
                                                        >
                                                            <FaTrash />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}


                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>


                )}
            </div>

            {showEditModal && editItem && (
                <div style={modalStyle}>
                    <div style={closeButtonStyle} onClick={() => setShowEditModal(false)}>
                        <span style={closeIconStyle}>×</span> {/* Close icon */}
                    </div>
                    <br></br>
                    {/* <h3 style={{ justifyContent: "center", textAlign: "center", fontWeight: "bold" }}>Edit Dish</h3> */}
                    {/* ajasd all the data of the code and showEditModal && editItem && div style= {modalstyle */}

                    <div style={inputContainerStyle}>

                        <input
                            id="dishName"
                            type="text"
                            value={editItem.dishName}
                            onChange={(e) => setEditItem({ ...editItem, dishName: e.target.value })}
                            style={inputFieldStyle}
                        />
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '20px 0' }}>
                        <div style={imagePreviewStyle}>
                            <label htmlFor="dishImage" style={{ cursor: 'pointer' }}>
                                <img
                                    src={editItem.image || 'https://via.placeholder.com/100x100'}
                                    alt="Preview"
                                    style={imageStyle}
                                />
                            </label>

                            <input
                                id="dishImage"
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleEditImageChange(e)}
                                style={{ display: 'none' }}
                            />
                        </div>
                    </div>



                    <div style={buttonContainerStyle}>
                        <button onClick={submitEdit} style={buttonStyle}>Update</button>
                    </div>
                </div>
            )}



            {showSubcategoryPopup && (
                <div
                    style={{
                        position: 'fixed',
                        top: 63,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0,0,0,0.6)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1000,
                        padding: '20px',
                        boxSizing: 'border-box',
                    }}
                >
                    <div
                        style={{
                            height: "77vh",
                            overflow: "auto",
                            position: 'relative',  // needed for close icon positioning
                            backgroundColor: '#fff',
                            padding: '30px 25px',
                            borderRadius: '12px',
                            width: '400px',
                            maxWidth: '95%',
                            boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '15px',
                            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                        }}
                    >
                        {/* Close Icon */}
                        <div
                            onClick={() => setShowSubcategoryPopup(false)}
                            style={{
                                position: 'absolute',
                                top: '15px',
                                right: '15px',
                                fontSize: '22px',
                                fontWeight: '700',
                                color: '#999',
                                cursor: 'pointer',
                                userSelect: 'none',
                                transition: 'color 0.3s',
                            }}
                            onMouseEnter={e => (e.currentTarget.style.color = '#00b894')}
                            onMouseLeave={e => (e.currentTarget.style.color = '#999')}
                            aria-label="Close popup"
                            title="Close"
                        >
                            &times;
                        </div>

                        <h3 style={{ margin: 0, fontWeight: '600', fontSize: '1.3rem', color: '#333' }}>
                            Add Subcategory for: <span style={{ color: '#00b894' }}>{parentDishDetails?.dishType}</span>
                        </h3>

                        <input
                            type="text"
                            value={subDishName}
                            onChange={(e) => setSubDishName(e.target.value)}
                            placeholder="Subcategory Dish Name"
                            style={{
                                padding: '10px 12px',
                                fontSize: '1rem',
                                borderRadius: '6px',
                                border: '1.8px solid #ccc',
                                outline: 'none',
                                transition: 'border-color 0.3s',
                            }}
                            onFocus={e => e.target.style.borderColor = '#00b894'}
                            onBlur={e => e.target.style.borderColor = '#ccc'}
                        />

                        <input
                            type="number"
                            value={price}
                            onChange={(e) => setPrice(e.target.value)}
                            placeholder="Price"
                            style={{
                                padding: '10px 12px',
                                fontSize: '1rem',
                                borderRadius: '6px',
                                border: '1.8px solid #ccc',
                                outline: 'none',
                                transition: 'border-color 0.3s',
                            }}
                            onFocus={e => e.target.style.borderColor = '#00b894'}
                            onBlur={e => e.target.style.borderColor = '#ccc'}
                        />




                        <select
                            value={quantityType}
                            onChange={(e) => setQuantityType(e.target.value)}
                            style={{
                                padding: '10px 12px',
                                fontSize: '1rem',
                                borderRadius: '6px',
                                border: '1.8px solid #ccc',
                                outline: 'none',
                                transition: 'border-color 0.3s',
                            }}
                        >
                            <option value="">Select Quantity Type</option>
                            <option value="KG">KG</option>
                            <option value="GRAM">GRAM</option>
                            <option value="PIECE">PIECE</option>
                            <option value="PACK">PACK</option>
                            <option value="DOZEN">DOZEN</option>
                        </select>

                        {/* ✅ Quantity Value Input */}
                        <input
                            type="text"
                            value={quantityValue}
                            onChange={(e) => setQuantityValue(e.target.value)}
                            placeholder="Enter Quantity Value (e.g., 500g, 2 pcs)"
                            style={{
                                padding: '10px 12px',
                                fontSize: '1rem',
                                borderRadius: '6px',
                                border: '1.8px solid #ccc',
                                outline: 'none',
                                transition: 'border-color 0.3s',
                            }}

                        />


                        {/* ✅ Conditional Input for Packages / Litres */}
                        <input
                            type="number"
                            value={discount}
                            onChange={(e) => setdiscount(e.target.value)}
                            placeholder="discount"
                            style={{
                                padding: '10px 12px',
                                fontSize: '1rem',
                                borderRadius: '6px',
                                border: '1.8px solid #ccc',
                                outline: 'none',
                                transition: 'border-color 0.3s',
                            }}
                            onFocus={e => e.target.style.borderColor = '#00b894'}
                            onBlur={e => e.target.style.borderColor = '#ccc'}
                        />
                        <input
                            type="number"
                            value={packingCharges}
                            onChange={(e) => setPackingCharges(e.target.value)}
                            placeholder="Packing Charges ₹"
                            style={{
                                padding: '10px 12px',
                                fontSize: '1rem',
                                borderRadius: '6px',
                                border: '1.8px solid #ccc',
                                outline: 'none',
                                transition: 'border-color 0.3s',
                            }}
                        />

                        <input
                            type="number"
                            value={gstPercentage}
                            onChange={(e) => setGstPercentage(e.target.value)}
                            placeholder="GST %"
                            style={{
                                padding: '10px 12px',
                                fontSize: '1rem',
                                borderRadius: '6px',
                                border: '1.8px solid #ccc',
                                outline: 'none',
                                transition: 'border-color 0.3s',
                            }}
                        />
                        <input
                            type="text"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Description"
                            style={{
                                padding: '10px 12px',
                                fontSize: '1rem',
                                borderRadius: '6px',
                                border: '1.8px solid #ccc',
                                outline: 'none',
                                transition: 'border-color 0.3s',
                            }}
                            onFocus={e => e.target.style.borderColor = '#00b894'}
                            onBlur={e => e.target.style.borderColor = '#ccc'}
                        />


                        <div
                            style={{
                                width: '100%',
                                maxWidth: '175px',             // optional
                                minHeight: '138px',
                                // height: '180px',               // increased height
                                border: '2px dashed #bbb',
                                borderRadius: '10px',
                                margin: '15px auto',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                backgroundColor: '#fafafa',
                                overflow: 'visible',           // ✅ changed from 'hidden' to 'visible'
                                transition: 'border-color 0.3s',
                            }}
                            onClick={() => document.getElementById('hiddenFileInput').click()}
                            onMouseEnter={e => (e.currentTarget.style.borderColor = '#00b894')}
                            onMouseLeave={e => (e.currentTarget.style.borderColor = '#bbb')}
                        >
                            {image ? (
                                <img
                                    src={image}
                                    alt="Preview"
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',       // ✅ changed to 'contain' to avoid distortion/cutoff
                                        borderRadius: '10px',
                                    }}
                                />
                            ) : (
                                <div
                                    style={{
                                        fontSize: '50px',
                                        color: '#ccc',
                                        fontWeight: 'bold',
                                        userSelect: 'none',
                                    }}
                                >
                                    +
                                </div>
                            )}
                        </div>

                        <input
                            id="hiddenFileInput"
                            type="file"
                            accept="image/*"
                            onChange={handleSubImageChange}
                            style={{ display: 'none' }}
                        />

                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '10px',
                            }}
                        >
                            <button
                                onClick={handleSubcategorySubmit}
                                style={{
                                    backgroundColor: '#00b894',
                                    color: 'white',
                                    padding: '10px 20px',
                                    border: 'none',
                                    borderRadius: '6px',
                                    fontWeight: '600',
                                    fontSize: '1rem',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s',
                                }}
                                onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#019973')}
                                onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#00b894')}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}


            {showSubEditModal && (
                <div style={modalOverlayStyle}>
                    <div style={modalContentStyle}>
                        {/* Close Icon */}
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <button
                                onClick={() => setShowSubEditModal(false)}
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    fontSize: '20px',
                                    cursor: 'pointer',
                                    color: '#888',
                                }}
                            >
                                &times;
                            </button>
                        </div>

                        {/* <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Edit Subcategory</h2> */}

                        {/* Dish Name */}
                        <div style={{ marginBottom: '15px' }}>
                            {/* <label style={{ fontWeight: '500', display: 'block', marginBottom: '6px' }}>
                Dish Name:
              </label> */}
                            <input
                                type="text"
                                value={editSubItem.subName}
                                onChange={(e) => setEditSubItem((prev) => ({ ...prev, subName: e.target.value }))}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: '6px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px',
                                }}
                            />
                        </div>

                        {/* Price */}
                        <div style={{ marginBottom: '15px' }}>
                            {/* <label style={{ fontWeight: '500', display: 'block', marginBottom: '6px' }}>
                Price:
              </label> */}
                            <input
                                type="number"
                                value={editSubItem.price}
                                onChange={(e) => setEditSubItem((prev) => ({ ...prev, price: e.target.value }))}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: '6px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px',
                                }}
                            />
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            {/* <label style={{ fontWeight: '500', display: 'block', marginBottom: '6px' }}>
                                     Price:
                                          </label> */}
                            <input
                                type="number"
                                value={editSubItem.stockQuantity}
                                onChange={(e) => setEditSubItem((prev) => ({ ...prev, stockQuantity: e.target.value }))}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: '6px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px',
                                }}
                            />
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            {/* <label style={{ fontWeight: '500', display: 'block', marginBottom: '6px' }}>
                                     Price:
                                          </label> */}
                            <input
                                type="number"
                                value={editSubItem.gst}
                                onChange={(e) => setEditSubItem((prev) => ({ ...prev, gst: e.target.value }))}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: '6px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px',
                                }}
                            />
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            {/* <label style={{ fontWeight: '500', display: 'block', marginBottom: '6px' }}>
                                     Price: discount
                                          </label> */}
                            <input
                                type="number"
                                value={editSubItem.packingCharges}
                                onChange={(e) => setEditSubItem((prev) => ({ ...prev, packingCharges: e.target.value }))}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: '6px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px',
                                }}
                            />
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            {/* <label style={{ fontWeight: '500', display: 'block', marginBottom: '6px' }}>
                                     Price:
                                          </label> */}
                            <input
                                type="text"
                                value={editSubItem.chefType}
                                onChange={(e) => setEditSubItem((prev) => ({ ...prev, chefType: e.target.value }))}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: '6px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px',
                                }}
                            />
                        </div>
                        {/* Image Preview and Upload */}
                        <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
                            <div style={imagePreviewStyle}>
                                <label htmlFor="subDishImage" style={{ cursor: 'pointer' }}>
                                    <img
                                        src={editSubItem.image || 'https://via.placeholder.com/100x100'}
                                        alt="Preview"
                                        style={{
                                            width: '100px',
                                            height: '100px',
                                            objectFit: 'cover',
                                            borderRadius: '10px',
                                            border: '1px solid #ccc',
                                        }}
                                    />

                                </label>
                                <input
                                    id="subDishImage"
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) =>
                                        setEditSubItem({
                                            ...editSubItem,
                                            newImageFile: e.target.files[0],
                                            image: URL.createObjectURL(e.target.files[0]), // for preview
                                        })
                                    }
                                    style={{ display: 'none' }}
                                />
                            </div>
                        </div>

                        {/* Save Button */}
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <button onClick={submitEditSubcategory} style={submitButtonStyle}>
                                update
                            </button>
                        </div>
                    </div>
                </div>
            )}






        </div>
    );
};

const modalOverlayStyle = {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
};

const modalContentStyle = {
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '20px',
    width: '320px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
};

const submitButtonStyle = {
    backgroundColor: '#00b894',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '4px',
    cursor: 'pointer',
};


const tableHeaderStyle = {
    border: '1px solid #ddd',
    textAlign: 'center',
    fontWeight: 'bold',
    backgroundColor: '#b15cd6',
    color: 'white',
};

const tableCellStyle = {
    border: '1px solid #ddd',
    textAlign: 'center',
};

const evenRowStyle = { backgroundColor: '#fff' };
const oddRowStyle = { backgroundColor: '#fff' };

const inputStyle = {
    // width: '100%',
    border: 'none',
    backgroundColor: 'transparent',
    textAlign: 'center',
};

const addButtonStyle = {
    backgroundColor: '#fff',
    color: 'green',
    border: 'none',
    cursor: 'pointer',
    borderRadius: '5px',
    marginRight: '10px',
    fontSize: "20px"
};

const deleteButtonStyle = {
    backgroundColor: '#fff',
    color: 'red',
    border: 'none',
    cursor: 'pointer',
    borderRadius: '5px',
    fontSize: "20px"
};

const importExportButton = {
    height: '35px',
    marginTop: "20px",
    borderRadius: "4px",
    border: "none",
    backgroundColor: "#b15cd6",
    color: "white",
    fontWeight: 'bold',
};

export default Grocerystandardmenu;
